export default __webpack_public_path__ + "static/media/hissimusa.63f443bf.mp3";